<script setup lang="ts">

import PlanetOreLayer from '@/components/Sections/Resources/Layers/PlanetOreLayer.vue'
import RingPlanetOreLayer from '@/components/Sections/Resources/Layers/RingPlanetOreLayer.vue'
import PlanetOreTradeLayer from '@/components/Sections/Resources/Layers/PlanetOreTradeLayer.vue'
import FactoryLayer from '@/components/Sections/Resources/Layers/FactoryLayer.vue'
import StorageLayer from '@/components/Sections/Resources/Layers/StorageLayer.vue'
import TerraformLayer from '@/components/Sections/Resources/Layers/TerraformLayer.vue'
import DysonLayer from '@/components/Sections/Resources/Layers/DysonLayer.vue'
import RingworldLayer from '@/components/Sections/Resources/Layers/RingworldLayer.vue'

</script>

<template>
  <div class="w-full h-full overflow-x-auto overflow-y-auto">
    <div class="relative no-scrollbar mx-auto min-w-[120rem] w-[120rem]">
      <StorageLayer></StorageLayer>
      <PlanetOreLayer></PlanetOreLayer>
      <RingPlanetOreLayer></RingPlanetOreLayer>
      <PlanetOreTradeLayer></PlanetOreTradeLayer>
      <FactoryLayer></FactoryLayer>
      <TerraformLayer></TerraformLayer>
      <DysonLayer></DysonLayer>
      <RingworldLayer></RingworldLayer>
      <div class="absolute" style="top:170rem;left:1rem;width:1rem;height:1rem;'"></div>
    </div>
  </div>
</template>

<style scoped lang="scss">

</style>